var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M84.735,17.614H13.973c-6.886,0-12.488,4.848-12.488,10.808v36.026c0,5.96,5.602,10.808,12.488,10.808 h4.162v18.833L42.61,75.256h42.125c6.887,0,12.488-4.848,12.488-10.808V28.422C97.224,22.461,91.622,17.614,84.735,17.614z  M88.897,64.448c0,1.983-1.865,3.603-4.162,3.603H39.448L26.46,78.042v-9.991H13.973c-2.297,0-4.163-1.619-4.163-3.603V28.422 c0-1.986,1.866-3.603,4.163-3.603h70.762c2.297,0,4.162,1.616,4.162,3.603V64.448z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 49.358,
    cy: 41.031,
    rx: 6.244,
    ry: 5.404
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.439,50.037h-4.162c-4.598,0-8.325,3.227-8.325,7.206v3.603h20.813v-3.603 C59.765,53.264,56.037,50.037,51.439,50.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M74.33,46.435c3.45,0,6.243-2.417,6.243-5.404c0-2.985-2.793-5.404-6.243-5.404 c-3.451,0-6.244,2.419-6.244,5.404C68.086,44.018,70.879,46.435,74.33,46.435z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76.411,50.037h-4.163c-4.598,0-8.324,3.227-8.324,7.206v3.603h20.812v-3.603 C84.735,53.264,81.009,50.037,76.411,50.037z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 24.379,
    cy: 41.031,
    rx: 6.244,
    ry: 5.404
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.46,50.037h-4.162c-4.598,0-8.325,3.227-8.325,7.206v3.603h20.813v-3.603 C34.786,53.264,31.058,50.037,26.46,50.037z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.52313332fd34e97c62111d6db23059c7.svg";
export { ForwardRef as ReactComponent };